export default "__VITE_ASSET__CBjNVSut__"